import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { DialogContent } from "../errors/DialogContent";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var DialogFacebookConnectFailureDOM = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.alert_anErrorOccurred_title, className: IdStyles.ModalBackgroundInfo, onClose: onClose },
        React.createElement("div", { className: "flex flex--stacked flex--guts h100" },
            React.createElement(DialogContent, { messageLocaId: IdLoca.accountSaveDialog_facebook_noSuccess_desc }),
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonPrimary, { onClick: onClose },
                    React.createElement("div", { className: IdStyles.TextBoldAccent },
                        React.createElement(TextLoca, { id: IdLoca.confirm })))))));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.FacebookConnectFailure)); },
}); };
export var DialogFacebookConnectFailure = connect(undefined, mapDispatch)(DialogFacebookConnectFailureDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/DialogFacebookConnectFailure.tsx
// module id = 2828
// module chunks = 3